<template>
  <div class="cx-wrap--article announcement__board">
    <div class="cx-div--outer">
      <div class="cx-t20 m-title" tabindex="0">{{$t('announcement.header')}}</div>
    </div>
    <div class="announcement__section">
      <template v-for="[channel, announcements] in Object.entries(announcementsGroup)">
          <section class="announcement__wrap">
          <div
            v-if="announcements.length == 0"
            class="cx-div cx-t10"
          >{{$t('announcement.emptyCaption')}}</div>

          <template v-for="announcement in announcements">
            <!-- type of message -->
            <div v-if='announcement.issuedTime' :key="announcement.issuedTime" class="cx-div announcement__item readmore_mask_pending">
              <div
                class="cx-div cx-t02 -fade3"
                tabindex="0"
              ><span><i class="fal fa-clock"></i></span> {{announcement.issuedTime | timestampToDateTimeString($te('common.fullDateTimeFormat') ? $t('common.fullDateTimeFormat') : undefined)}}</div>
              <div class="cx-div announcement__content" v-html="announcement.content" v-mask-readmore></div>
              <div class="readmore_mask_overlay"></div>
              <button class="cx-btn readmore_btn" @click="handleReadmoreClick">{{ $t('announcement.readmore') || 'announcement.readmore' }}</button>
            </div>
            <!-- type of info -->
            <article-content-render v-else :presetDetail="announcement" />
          </template>
        </section>
      </template>
    </div>
  </div>
</template>

<script>
let env;
if (process.env.NODE_ENV !== 'production') {
  env = 'development'
}
import ArticleContentRender from '@/components/ArticleContentRender';
import fakeData from '../../fake_api/data/announcementGrouping'

export default {
  name: "announcement-board",
  uit() {
    return [
      ["announcement", ["header", "emptyCaption", "readmore"]],
      ["common", ["fullDateTimeFormat"]],
    ];
  },
  components: {
    ArticleContentRender
  },
  computed: {
    announcementsGroup: function () {
      const {dev = ''} = this.$route.query

      // needed to be removed
      if(dev === 'grouping' && env === 'development') {
        const messageList = fakeData.messages
        const infoList = fakeData.information
        return this.groupByChannel([...messageList, ...infoList])
      }

      const messageList = this.$store.getters['announcement/getAnnouncements'](this.$i18n.locale)
      const infoList = this.$store.getters['announcement/getInformations'](this.$i18n.locale)

      return this.groupByChannel([...messageList, ...infoList])

    }
  },
  directives: {
    'mask-readmore': {
      inserted: function (el) {
        const itemEl = el.closest('.announcement__item')
        if (el.scrollHeight > 440) {
          itemEl.classList.add('readmore_mask');
        }
        itemEl.classList.remove('readmore_mask_pending');
        // const readmoreBlock = el.querySelector('.readmore_block')
        // const readmoreBtn = el.querySelector('.readmore_block + .cx-btn[onclick]')
        // if (readmoreBlock && readmoreBtn) {
        //   itemEl.classList.add('readmore_mask')
        //   readmoreBtn.addEventListener('click', e => {
        //     itemEl.classList.remove('readmore_mask')
        //   })
        // } else {
        //   itemEl.classList.remove('readmore_mask')
        // }
      }
    }
  },
  methods: {
    groupByChannel: function (itemList) {
      try {
        if (!itemList || itemList.length <= 0) {
          console.log("empty");
          return [];
        }

        const resultGroupList = {};
        const _itemList = [...itemList];
        const countChannel = _itemList.reduce((accumulator = {}, item) => {
          // case of information
          if(typeof(item.channel) === 'string') return [
            ...accumulator,
            item.channel
          ]
 
          // case of Message
          return [
            ...accumulator,
            ...item.channels,
          ]
        })
        
        for (const [index, item] of _itemList.entries()) {
          for (const itemChannel of countChannel) {
            const channel = itemChannel

            // message or info
            if ((item.channels && item.channels.includes(channel)) || item.channel === channel) {
              if (!resultGroupList[channel]) {
                resultGroupList[channel] = [];
              }
              resultGroupList[channel].push(item);
              break;
            }
          }
        }

        return resultGroupList;
      } catch (e) {
        console.error(e);
        return [];
      }
    },
    handleReadmoreClick: function (e) {
      e.target.closest('.announcement__item').classList.remove('readmore_mask')
    },
  },
};
</script>

<style lang="scss">
.announcement {
  &__board {
    text-align: left;
    a{
      color: $color-green;
      font-weight: bold;
      &:hover{
        color: $color-text;
      }
    }
  }
  &__section {
    // border: 1px solid $color-border;
    // padding-bottom: $space-base;
  }
  &__item {
    border-bottom: 1px solid $color-border;
    padding-bottom: $space-base;
  }
  &__content {
    white-space: pre-wrap;
  }
  &__wrap {
    margin-bottom: $space-xl;
  }
}

.announcement__content {
  position: relative;

  .readmore_block {
    position: relative;
    display: block !important;
  }
  .readmore_block + .cx-btn[onclick] {
    position: absolute;
    display: none !important;
  }
}

.announcement__item {
  position: relative;

  &.readmore_mask_pending {
    opacity: 0;
  }

  .readmore_mask_overlay,
  .readmore_btn {
    display: none;
  }

  &.readmore_mask {
    max-height: 500px;
    overflow: hidden;

    .readmore_mask_overlay {
      position: absolute;
      display: block;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 120px;
      background: linear-gradient(180deg, rgba(247, 247, 247, 0) 0%, rgba(247, 247, 247, 0.8) 50%, rgba(247, 247, 247, 1) 100%);
    }
    
    .readmore_btn {
      position: absolute;
      display: block;
      left: 0;
      bottom: 0;
      margin-bottom: 1em;
    }
  }
}
</style>
